import React from 'react'
import PropTypes from 'prop-types'

import { Chip, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'

import EmailEventChip from 'components/common/chip/EmailEventChip'
import { ReactComponent as PaperPlane } from 'assets/PaperPlane.svg'
import { grey } from '@mui/material/colors'

const EmailActivityContent = ({ chipGridWidth, event, emailTo, fullDateTime, sendType }) => (
  <Grid container spacing={2.5} alignItems="center" size={12}>
    <Grid minWidth={chipGridWidth} size="auto">
      <EmailEventChip eventType={event} />
    </Grid>
    <Grid size="grow">
      <Typography variant="h6" fontWeight={500} color="textPrimary">
        {`To: ${emailTo}`}
      </Typography>
      <Typography variant="caption">{fullDateTime}</Typography>
    </Grid>
    <Grid minWidth={chipGridWidth} size="auto" sx={{ textAlign: 'right' }}>
      <Chip
        size="small"
        avatar={<PaperPlane />}
        label={sendType}
        sx={{
          fontWeight: 600,
          border: '1px solid',
          borderColor: grey[400],
          backgroundColor: 'transparent',
          '& .MuiChip-avatar': {
            backgroundColor: grey[400],
            borderRadius: '50%',
          },
        }}
      />
    </Grid>
  </Grid>
)

EmailActivityContent.propTypes = {
  chipGridWidth: PropTypes.number,
  event: PropTypes.string,
  emailTo: PropTypes.string,
  fullDateTime: PropTypes.string,
  sendType: PropTypes.string,
}

export default EmailActivityContent
